import { throwError } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'

import { env } from '../../../shared/env'

const baseURL = env.SERVER_ADDR

const requestHeader = () => {
  const headers = {
    'Content-Type': 'application/json',
  }
  const userData = JSON.parse(localStorage.getItem('user_info') || '{}')
  let token: string | boolean = false
  if (userData.token) {
    token = userData.token
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}

const objToQueryString = (obj) => {
  return Object.keys(obj)
    .map((key) => key + '=' + obj[key])
    .join('&')
}
const handleError = (operation: string) => (err) => {
  const errMsg = `Error in ${operation}()`

  if (err.status === 401) {
    localStorage.clear()
    window.location.href = '/auth/login'
  }
  return throwError(() => console.error(errMsg))
}

export const getDashboardSummary = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/all?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('login')))

export const getDashboardOrders = (payload: any) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/orders?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('getDashboardOrders')))

export const getDashboardRevenue = (payload: any) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/revenue?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('getDashboardOrders')))

export const getDashboardReturningCustomers = (payload: any) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/returning-customers?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('getDashboardOrders')))

export const getGetAgingOrdersData = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/orders-aging-report?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('getGetAgingOrdersData')))

export const getDashboardComplaints = (payload: any) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/complaints?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('getGetAgingOrdersData')))

export const getDashboardLandVsShip = (payload: any) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/land-vs-dispatch?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('login')))

export const getDashboardProducts = (payload: any) => {
  const queryParams = new URLSearchParams({
    start_date: payload.start_date,
    end_date: payload.end_date,
    data_type: payload.data_type,
  })

  if (payload.limit) {
    queryParams.append('limit', payload.limit.toString())
  }

  return ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/products?${queryParams.toString()}`,
  }).pipe(catchError(handleError('getDashboardProducts')))
}

export const getDashboardCollections = (payload: any) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/collections?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('getDashboardCollections')))

export const getHeatMap = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/heatmap/data?start_date=${payload.start_date}&end_date=${payload.end_date}`,
  }).pipe(catchError(handleError('login')))

export const getReportsSummary = (filters) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/reports/dashboards/orders?${objToQueryString(
      filters,
    )}`,
  }).pipe(catchError(handleError('login')))

export const getDispatchesSummary = (filters) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/reports/dashboards/dispatches?${objToQueryString(
      filters,
    )}`,
  }).pipe(catchError(handleError('login')))

export const getOrdersSummary = (filters) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/report/dayend?${objToQueryString(filters)}`,
  }).pipe(catchError(handleError('login')))

export const getProfitAnalyticsHeaders = (filters: {
  page: number
  page_size: number
  date?: string
  start_date?: string
  end_date?: string
}) => {
  const params: Record<string, string | number> = {
    page: filters.page,
    page_size: filters.page_size,
  }

  if (filters.start_date && filters.end_date) {
    params.start_date = filters.start_date
    params.end_date = filters.end_date
  } else if (filters.date) {
    params.date = filters.date
  }

  return ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/daily-product-profit/headers?${objToQueryString(
      params,
    )}`,
  }).pipe(catchError(handleError('getProfitAnalyticsHeaders')))
}

export const getProfitAnalyticsLines = (headerId: string | number) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dashboard/daily-product-profit/${headerId}/lines`,
  }).pipe(catchError(handleError('getProfitAnalyticsLines')))
